import {useTranslation} from 'react-i18next';
import {Stack, Typography} from '@mui/material';
import './templates.professional-caregiver.scss';
import {translations} from '../../../../../../i18n/translations';
import {Modal, ModalProps} from '../../../../../../components/modal/modal';
import {EntityTemplate} from '../../../../../../backend/responses/entity-template';

interface SettingsTemplatesModalProps extends Omit<ModalProps, 'actions'> {
  submitting: boolean;
  template: EntityTemplate;
  onClose: () => void;
  onDelete: () => void;
}

export const SettingsTemplatesModal = ({
  submitting,
  template,
  onClose,
  onDelete,
}: SettingsTemplatesModalProps) => {
  const {t} = useTranslation();

  return (
    <Modal
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="delete-template-modal"
      preventCloseClick
      actions={[
        {
          label: t(translations.office.professional_caregiver.settings.templates.cancel),
          type: 'destructive',
          onClick: onClose,
        },
        {
          label: t(translations.office.professional_caregiver.settings.templates.delete),
          type: 'nondestructive',
          onClick: onDelete,
          loading: submitting,
          disabled: false,
        },
      ]}
    >
      <Stack className="container">
        <Typography className="title">
          {t(translations.office.professional_caregiver.settings.templates.delete_title, {
            name: template.name,
          })}
        </Typography>
        <Typography className="subtitle">
          {t(translations.office.professional_caregiver.settings.templates.delete_subtitle)}
        </Typography>
      </Stack>
    </Modal>
  );
};
